import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import API_URL from "../../config/ApiUrl";

const INT = API_URL.INTEGRATION;

// Tenant-facing: catalog + effective enablement (drives the /integrations page).
export const getIntegrations = createAsyncThunk(
  "integration/getForTenant",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(INT.LIST);
      return data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

// Admin: per-tenant integration list (catalog + default + override flag).
export const getTenantIntegrations = createAsyncThunk(
  "integration/getForAdmin",
  async (tenantId, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(INT.ADMIN_LIST(tenantId));
      return data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

// Admin: enable/disable an integration for a tenant.
export const setTenantIntegration = createAsyncThunk(
  "integration/setForAdmin",
  async ({ tenantId, integrationId, isEnabled }, { rejectWithValue, dispatch }) => {
    try {
      await axios.put(INT.ADMIN_SET(tenantId), { integrationId, isEnabled });
      dispatch(getTenantIntegrations(tenantId));
      return true;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

const integrationSlice = createSlice({
  name: "integration",
  initialState: {
    integrations: [], // tenant-facing
    tenantIntegrations: [], // admin per-tenant
    isLoading: false,
    isSaving: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getIntegrations.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getIntegrations.fulfilled, (state, action) => {
        state.isLoading = false;
        state.integrations = action.payload || [];
      })
      .addCase(getIntegrations.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(getTenantIntegrations.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getTenantIntegrations.fulfilled, (state, action) => {
        state.isLoading = false;
        state.tenantIntegrations = action.payload || [];
      })
      .addCase(getTenantIntegrations.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(setTenantIntegration.pending, (state) => {
        state.isSaving = true;
      })
      .addCase(setTenantIntegration.fulfilled, (state) => {
        state.isSaving = false;
      })
      .addCase(setTenantIntegration.rejected, (state) => {
        state.isSaving = false;
      });
  },
});

export default integrationSlice.reducer;
